<template>
  <v-container
    fluid>
    <v-row>
      <v-col
        cols="12"
        :md="selectItem ? '8' : '12'"
        class="table-detail">
        <v-data-table
          :headers="header"
          :items="items"
          :options.sync="options"
          :items-per-page="options.itemsPerPage"
          :server-items-length="total"
          :loading="loading"
          :footer-props="{'items-per-page-options': [15, 25, 50, 100]}"
          class="w-full"
          @update:options="getData()"
        >
          <template v-slot:top>
            <v-toolbar flat>
              <v-toolbar-title>
                <span class="capitalize"> Lazada Request Logs </span>
              </v-toolbar-title>
              <v-divider
                class="mx-4"
                inset
                vertical />
              <v-spacer />
              <v-autocomplete
                v-model.trim="description"
                :items="allDescription"
                class="mb-2 mr-5 search-text-field"
                label="Description"
                hide-details
                @change="getData()" />
            </v-toolbar>
          </template>

          <template #[`item.createdAt`]="{ item }">
            {{ item.createdAt | dateTimeFormat() }}
          </template>
          <template #[`item.method`]="{ item }">
            <div
              class="text-bold method"
              :style="getMethodStyle(item.method)">
              {{ item.method.toUpperCase() }}
            </div>
          </template>
          <template #[`item.responseTime`]="{ item }">
            {{ item.responseTime ? `${item.responseTime}ms` : '-' }}
          </template>
          <template #[`item.description`]="{ item }">
            <span
              class="text-bold"
              :style="getStatusStyle(item.httpStatus)">{{ item.httpStatus }}</span> {{ item.description }}
          </template>
          <template #[`item.option`]="{ item }">
            <v-btn
              v-if="!selectItem || selectItem.id !== item.id"
              link
              icon
              x-small
              @click="showItemDetail(item)">
              <v-icon>
                mdi-magnify
              </v-icon>
            </v-btn>
          </template>
        </v-data-table>
      </v-col>
      <v-col
        v-if="selectItem"
        cols="12"
        md="4"
        class="pa-0">
        <div class="log-detail">
          <h3 class="text-bold mb-0">
            {{ selectItem.description }}
          </h3>
          <p class="mb-0 mt-2">
            <span
              :style="getStatusStyle(selectItem.httpStatus)"
              class="text-bold">{{ selectItem.httpStatus }}</span> {{ selectItem.statusText }}
          </p>
          <p class="mb-0">
            <b>Date </b>{{ selectItem.createdAt | dateTimeFormat() }}
          </p>
          <p class="mb-0">
            <b>Document NO </b> {{ selectItem.documentNo }}
          </p>
          <div class="mt-4">
            <a @click="scrollTo('Config')">#Config</a>
            <a
              class="ml-4"
              @click="scrollTo('Body')">#Body</a>
            <a
              class="ml-4"
              @click="scrollTo('Response')">#Response</a>
          </div>
          <div style="border: 1px solid #000;">
            <json-viewer
              :value="{ method: selectItem.method, baseUrl: selectItem.baseUrl }"
              :expand-depth="1"
              copyable />
          </div>
          <p
            ref="Config"
            class="mt-4">
            Config
          </p>
          <div style="border: 1px solid #000;">
            <json-viewer
              :value="selectItem.config"
              :expand-depth="1"
              copyable />
          </div>
          <p
            ref="Body"
            class="mt-4">
            Body
          </p>
          <div style="border: 1px solid #000;">
            <json-viewer
              :value="selectItem.body || {}"
              :expand-depth="5"
              copyable
              sort />
          </div>
          <p
            ref="Response"
            class="mt-4">
            Response
          </p>
          <div style="border: 1px solid #000;">
            <json-viewer
              :value="selectItem.result"
              :expand-depth="5"
              copyable
              sort />
          </div>
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import LazadaProvider from '@/resources/LazadaProvider'

const LazadaService = new LazadaProvider()

export default {
  components: {
    // BcLogDetail
  },
  data () {
    return {
      loading: false,
      selectItem: null,
      showDetail: false,
      total: 0,
      description: 'All',
      allDescription: [
        'All',
        'Get access token with authCode',
        'Refresh access token',
        'Get sellers',
        'Get products',
        'Get product by id',
        'Get category tree',
        'Get category attributes',
        'Get category suggestion',
        'Get order detail by id',
        'Get orders',
        'Get order items by id',
        'Get reverse order detail by id',
        'Get brands',
        'Get shipment provider',
        'Create product',
        'Update product',
        'Remove product',
        'Adjust sellable quantity',
        'Update sellable quantity',
        'Update stock quantity',
        'Upload image',
        'Pack order',
        'Print AWB',
        'Ship order',
        'Get documents',
        'Get cancel reasons',
        'Cancel order'
      ],
      options: {
        page: 1,
        itemsPerPage: 15,
        sortBy: ['createdAt'],
        sortDesc: [true]
      },
      header: [
        {
          text: 'Date',
          value: 'createdAt',
          sortable: false
        },
        {
          text: 'Method',
          value: 'method',
          sortable: false
        },
        {
          text: 'Response Time',
          value: 'responseTime',
          align: 'center',
          sortable: false
        },
        {
          text: 'Description',
          value: 'description',
          sortable: false
        },
        {
          text: 'Options',
          value: 'option',
          align: 'center',
          sortable: false
        }
      ],
      items: []
    }
  },
  created () {
    this.getData(true)
  },
  methods: {
    showItemDetail (item) {
      this.selectItem = item
      this.showDetail = true
    },
    scrollTo (tag) {
      const el = this.$refs[tag]
      if (el) {
        el.scrollIntoView({ behavior: 'smooth' })
      }
    },
    getMethodStyle (method) {
      switch (method.toUpperCase()) {
        case 'GET':
          return 'color: #3b9c28; background-color: #eef6e9;'
        case 'POST':
          return 'color: #e29f0d; background-color: #fff7ea;'
        case 'PUT':
          return 'color: #379afe; background-color: #edf3fe;'
        case 'DELETE':
          return 'color: #e93e4c; background-color: #ffecec;'
        default:
          return 'color: #18171d; background-color: #f8f8f8;'
      }
    },
    getStatusStyle (status) {
      if (+status >= 200 && +status < 300) {
        return 'color: #4CAF50;'
      }
      if (+status < 600) {
        return 'color: #F44336'
      }

      return ''
    },
    async getData (clear = false) {
      if (clear) {
        this.options.page = 1
      }
      try {
        this.loading = true
        const { data: { results, total } } = await LazadaService.getRequestLogs(
          {
            page: this.options.page,
            limit: this.options.itemsPerPage,
            sortBy: this.options.sortBy[0],
            sortOrder: this.options.sortDesc[0] ? 'desc' : 'asc',
            description: this.description
          }
        )

        this.items = results
        this.total = total
        if (clear && results.length !== 0) {
          this.selectItem = this.items[0]
        }
      } catch (error) {
        this.$store.dispatch('Components/setSnackbar', {
          value: true,
          message: `Error ${error.message}`,
          type: 'error'
        })
      } finally {
        this.loading = false
      }
    }
  }
}
</script>
<style scoped>
.table-detail {
  height: calc(100vh - 80px);
  overflow-y: auto;
  background-color: #fff;
}
.log-detail {
  width: 100%;
  margin-left: 10px;
  padding: 10px;
  height: 100%;
  overflow-y: auto;
  height: calc(100vh - 80px);
  background-color: #fff;
}
.method {
  padding: 4px;
  border-radius: 6px;
  width: 60px;
  text-align: center;
}
</style>
